<template>
    <Admin
        :title="__('Translations', null, $page.props.profile_locale)"
    >
    <div class="relative">
        <div class="flex mb-4">
            <button
                class="border-b px-4 cursor-pointer hover:bg-gray-50"
                v-for="(lang, key) in $page.props.languages"
                :key="key"
                :class="{
                    ['font-bold bg-gray-100'] : route().params.locale == key || (!route().params.locale && $page.props.locale == key)
                }"
                @click="form_filters.locale = key"
            >
                {{ key }}
            </button>
        </div>
        <div class="flex  flex-wrap mb-4">
            <button
                class="border-b px-4 cursor-pointer hover:bg-gray-50"
                :class="{
                    ['font-bold bg-gray-100'] : !route().params.type
                }"
                @click="form_filters.type = null"
            >
                defaults
            </button>
            <button
                class="border-b px-4 cursor-pointer hover:bg-gray-50"
                v-for="(type, key) in types"
                :key="key"
                :class="{
                    ['font-bold bg-gray-100'] : route().params.type == type
                }"
                @click="form_filters.type = type"
            >
                {{ type == 'languages' ? 'countries' : type }}
            </button>
        </div>
        <div class="mb-4">
            <Checkbox
                :label="__('Show untranslated', null, $page.props.profile_locale)"
                id="untranslated"
                v-model="form.untranslated"
            />

            <form @submit.prevent="search(form_filters)" class="flex items-center mt-5 space-x-2">
            <InputLabel
                id="text"
                v-model="text"
            />
            <Button type="submit">{{__('Search', null, $page.props.profile_locale)}}</Button>
            </form>
        </div>
        <div class="text-xs text-right ml-auto flex justify-end items-end">
            <div class="bg-gray-900 text-gray-200 p-2 rounded-md shadow-md">Słowa takie jak <span class="bg-red-700 rounded-md px-1 text-gray-200 font-bold">:value</span> pozostaw bez zmian.<br>Są one potrzebne do poprawnego wypisywania danych</div>
        </div>
        <div v-if="!loading">
            <ul class="flex mb-3 justify-center items-center"
                v-if="filterTranslations.length > 1"
            >
                <button
                    as="li"
                    class="px-2 py-1 bg-gray-100 cursor-pointer"
                    :class="{
                        ['bg-gray-900 text-gray-200'] : form.page == item,
                        ['hover:bg-gray-300'] : form.page != item,
                        ['rounded-l-md border'] : key == 0,
                        ['border-t border-b border-r'] : key != 0 && key != filterTranslations.length - 1,
                        ['rounded-r-md border border-l-0'] : key == filterTranslations.length - 1,
                    }"
                    v-for="(item, key) in filterTranslations.length" :key="key"
                    @click="form.page = item"
                    v-html="item"
                />
            </ul>

            <ul
                class="grid grid-cols-1 gap-2 border rounded-md"
            >
                <li
                    v-for="(value, index) in filterTranslations[form.page - 1]" :key="index"
                    class="p-2 grid gap-2 text-sm lg:grid-cols-2 even:bg-gray-100"
                >
                    <span class="flex items-center font-bold" v-html="form_filters.type == 'countries' ? ( index +'/'+ __('countries.' + index, null, $page.props.profile_locale) ) : index.replace(/\n/g, '<br />')"></span>
                    <InputLabel
                        v-model.lazy="filterTranslations[form.page - 1][index]"
                        type="textarea"
                        @change="saveTranslate(index)"
                        :enterAction="true"
                        :auto-height="true"
                        :read-only="form.wait"
                    />
                </li>
            </ul>
            <ul class="flex mt-3 justify-center items-center"
                v-if="filterTranslations.length > 1"
            >
                <button
                    as="li"
                    class="px-2 py-1 bg-gray-100 cursor-pointer"
                    :class="{
                        ['bg-gray-900 text-gray-200'] : form.page == item,
                        ['hover:bg-gray-300'] : form.page != item,
                        ['rounded-l-md border'] : key == 0,
                        ['border-t border-b border-r'] : key != 0 && key != filterTranslations.length - 1,
                        ['rounded-r-md border border-l-0'] : key == filterTranslations.length - 1,
                    }"
                    v-for="(item, key) in filterTranslations.length" :key="key"
                    @click="form.page = item"
                    v-html="item"
                />
            </ul>
        </div>
        <div
            :class="[loading ? 'absolute inset-0 bg-gray-200 bg-opacity-50 flex justify-center items-center' : '']"
            v-else
        >
            <Spinner
                class="h-10 w-10 text-gray-900"
            />
        </div>
        <div v-if="Object.keys(filterTranslations).length == 0">{{ __('It looks like all the words have been translated', null, $page.props.profile_locale) }}</div>
    </div>
    </Admin>
</template>

<script>
import Admin from '@/Layouts/Admin';
import InputLabel from 'UI/InputLabel';
import Spinner from 'UI/Spinner';
import { ref } from '@vue/reactivity';
import { Inertia } from '@inertiajs/inertia';
import Checkbox from 'UI/Checkbox';
import { watch } from '@vue/runtime-core';
import Button from 'UI/Button';

import { usePage } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Admin,
        InputLabel,
        Spinner,
        Checkbox,
        Button,
    },

    props: ['translations', 'types'],

    setup(props) {
        const loading = ref(true);

        if(props.translations) loading.value = false;

        function saveTranslate(val) {
            form.value.wait = true;

            Inertia.post(window.location.href, {
                text: val,
                value: filterTranslations.value[form.value.page - 1][val],
            },
            {
                preserveScroll: true,
                onSuccess: () => {
                    filters(form.value),
                    form.value.wait = false;

                    let locale = route().params.locale ? route().params.locale : usePage().props.value.locale;
                    let type = route().params.type ? route().params.type : null

                    if(type) val = (type + '.' + val)
                    window.i18n[locale][val] = filterTranslations.value[form.value.page - 1][val];
                }
            })
        }
        const form = ref({
            untranslated: false,
            itemsLength: 50,
            page: 1,
            wait: false,
        })
        const form_filters = ref({
            locale: route().params.locale,
            type: route().params.type,
            text: null,
        });
        const text = ref(route().params.text);

        watch(form_filters.value, (val) => { search(val) })

        function search(val) {
            loading.value = true;

            Inertia.get(route('dashboard.admin.translations'), {
                locale: val.locale,
                type: val.type,
                text: text.value
            }, {
                replace: true,
                preserveScroll: true,
                preserveState: true,
                onSuccess: () => { loading.value = false, filters(form.value) },
            })
        }

        const filterTranslations = ref(props.translations);
        watch(form.value, (val, oldVal) => { filters(val) })

        function filters(val) {
            let newArr = [];
            let k = 0;
            let index = 1;

            if(val.untranslated) {
                props.translations.forEach(el => {
                    for (const [key, value] of Object.entries(el)) {

                        if(value == null) {
                            if(!newArr[k]) newArr[k] = {};
                            if(index <= 50) newArr[k][key] = value;
                            else {
                                k += 1;
                                index = 0;
                            }

                            index++;
                        }
                    }
                });
            }
            else newArr = props.translations;

            if(val.page > newArr.length) val.page = 1;

            filterTranslations.value = newArr;
        }
        function isString(o) { return typeof o == "string" };

        filters(form.value);

        return {
            saveTranslate,
            loading,
            form,
            isString,
            form_filters,
            text,

            filterTranslations,
            search,
        }
    }
}
</script>
